<template>
  <div id="pages-login" />
</template>

<script>
import { getCurrentInstance, onMounted } from 'vue-demi'
import authentication from '@/authentication'
import loginMixin from './loginMixin'

export default {
  name: 'AdLogin',
  mixins: [loginMixin],
  async beforeRouteEnter (to, from, next) {
    const url = new URL(location.href)
    const token = url.searchParams.get('token')
    const region = url.searchParams.get('region')
    if (!(region && token)) {
      await authentication.initialize()
    }
    next()
  },
  setup () {
    const { proxy } = getCurrentInstance()

    onMounted(async () => {
      const url = new URL(location.href)
      const token = url.searchParams.get('token')
      const region = url.searchParams.get('region')
      if (region && token) {
        try {
          await proxy.regionLogin(region, token)
          return
        } catch (err) {
          console.error('Region login failed:', err)
        }
      }
      await proxy.hklUserAdLogin()
    })

    return {}
  },
}
</script>
